import React from 'react';
import { extensions } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import highlighter from 'src/js/modules/highlighter';
import dividerPosition from 'src/js/modules/control-pane/constants/divider-position';
import common from '../constants/common';
import selectors from '../constants/selectors';
import addCompositeItem from '../helpers/add-composite-item';
import TriggerWithUpgradePopover from '../components/trigger-with-upgrade-popover';

const { Icon } = designSystem;
const { ADD_WIDGET_TRIGGER_ID } = common;

const addCompositeGroupControl = {
  id: ADD_WIDGET_TRIGGER_ID,
  trigger: (
    <TriggerWithUpgradePopover id={ADD_WIDGET_TRIGGER_ID}>
      <Icon glyph="plus-for-button" />
    </TriggerWithUpgradePopover>
  ),
  onTriggerClick: (elementId, { getContext }) => {
    const { controlPane } = getContext();

    controlPane.hidePane();
    highlighter.operations.hide();
    addCompositeItem({ elementId });
  },
  matches(liveElement) {
    const settings = extensions.accessors.getExtensionSettings(common.slug);

    return liveElement.matches(settings.querySelector);
  },
  highlightElement: (element) => {
    if (element.matches(selectors.COMPOSITE_GROUP)) {
      return [element];
    }

    return [element.closest(selectors.COMPOSITE_GROUP)];
  },
  priority: 0,
  divider: dividerPosition.LEFT,
};

export default addCompositeGroupControl;
